import { initializeCartForm } from 'lib/cart/services/cartForm'

/**
@public
Initializes cartForm state for the given campers and sessions, using an optional
existing saved cart
**/
const resetCartForm = (state, action) => {
  const { cart, campers, sessions } = action

  const cartForm = initializeCartForm({ cart, campers, sessions })

  return cartForm
}

export default resetCartForm
